import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { paxRoute } from "../../../common";
import { ListModelsResponse, ModelParams, ModelPricesResponse } from "./schemas";

export const list = oc
  .meta(
    paxRoute({ auth: { kind: "session" }, minimumTier: null, cost: "read" }),
    openapi({
      method: "GET",
      path: "/api/ai/models/v1alpha1",
      operationId: "ai.models.list",
      summary: "List models.",
      description: "Lists every model Pax prices, once per seller that bills it, with its SKUs.",
      successDescription: "Every priced model.",
    }),
  )
  .output(ListModelsResponse);

export const getPrices = oc
  .meta(
    paxRoute({ auth: { kind: "session" }, minimumTier: null, cost: "read" }),
    openapi({
      method: "GET",
      path: "/api/ai/models/v1alpha1/{model}/prices",
      operationId: "ai.models.prices.get",
      summary: "Get a model's prices.",
      description:
        "Reads a model's SKUs, from every seller that bills it, each with its flat list of prices: an amount per unit of one meter, and the dates, times of day and prompt sizes it holds for.",
      inputStructure: "detailed",
      successDescription: "The model's SKUs.",
    }),
  )
  .errors({ NOT_FOUND: { message: "Pax has no prices for that model." } })
  .input(z.object({ params: ModelParams }))
  .output(ModelPricesResponse);
